<template>
{{format(amount)}}
</template>

<script lang="ts" setup>
const {amount} = defineProps(['amount'])
const format = formatEuro;
</script>
